import { roundTo2 } from '../round-to-two';
import { countWorkdays, DEFAULT_WORKDAY_MASK, isoDaysToWorkdayMask } from '../workday-mask';
import type { EmploymentRow, IsoWeekday } from './employment.model';

const MAX_HOURS_PER_DAY = 24;

export function buildDefaultEmploymentRow({
  startDate,
  workingDays,
  fullTimeHoursPerWeek,
}: {
  startDate: string;
  workingDays: readonly IsoWeekday[] | null;
  fullTimeHoursPerWeek: number;
}): Omit<EmploymentRow, 'id'> {
  const workdayMask = workingDays?.length ? isoDaysToWorkdayMask(workingDays) : DEFAULT_WORKDAY_MASK;
  const hoursPerDay = roundTo2(fullTimeHoursPerWeek / countWorkdays(workdayMask));
  return {
    startDate,
    endDate: null,
    rrule: null,
    workdayMask,
    workloadHoursPerDay: Math.min(MAX_HOURS_PER_DAY, hoursPerDay),
    workloadPercent: null,
  };
}
